export default "__VITE_ASSET__DhiE4fMS__"